export function handleBatch(state, action, reducer) {
  if (action.meta && action.meta.isBatch) {
    const newState = getActions(action).reduce((state, action) => {
      return reducer(state, action)
    }, state)

    return newState
  }
  return reducer(state, action)
}

export function getActions(action) {
  return action.payload.actions
}
